export enum FederationUsersListSortProp {
	FIRSTNAME = 'firstName',
	LASTNAME = 'lastName',
	USERNAME = 'userName',
	USERSTATUS = 'userStatus',
	LASTCONNECTION = 'lastConnection'
}
